import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { IMarket, MarketService } from 'src/app/shared/services/market.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-USA-Markets',
  templateUrl: './USA-Markets.component.html',
  styleUrls: ['./USA-Markets.component.scss']
})
export class USAMarketsComponent implements OnInit {




  markets$: Observable<IMarket[]>;

  constructor(private _marketService: MarketService) { }

  ngOnInit(): void {
    this.markets$ = this._marketService.getMarkets$;
  }

  openLink(link: string) {

    if (!link.includes('https')) {
      link = 'https://' + link;
    }


    window.open(link, "_blank");

  }


  public onDisplayImage = (serverPath: string): string => {
    const imageApi = environment.imageApi;
    const result = `${imageApi}/${serverPath}`;

    return result;
  };

  websiteName(webName: string): string {

    // return webName;

    var firstWebNameDot = webName.indexOf('.');
    var lastWebNameDot = webName.lastIndexOf('.');
    var web = webName.substring(firstWebNameDot + 1, lastWebNameDot)
    return web;
  }

}
